<div [matMenuTriggerFor]="options.menu" #langMenuTrigger="matMenuTrigger">
  <div
    class="language-dropdown"
    role="button"
    (click)="options.open($event, langMenuTrigger)"
    data-name="spaces-manager-user-avatar-menu-settings-langauge-selection"
  >
    <span class="current-language">{{ (lang$ | async)?.label ?? '' | translate }}</span>
    <span class="material-icons">keyboard_arrow_down</span>
  </div>
</div>

<app-language-menu
  #options
  dataNamePrefix="spaces-manager-user-avatar-menu-settings-langauge-selection-"
  dataNameField="label"
></app-language-menu>
